/** Normalize user-entered tags: trim, drop `#`/`@` prefixes, drop empties, de-duplicate case-insensitively keeping first spelling. */
export function normalizeTags(input: readonly string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of input) {
    const tag = raw
      .trim()
      .replace(/^[#@]+/, "")
      .trim();
    if (!tag) continue;
    const key = tag.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(tag);
  }
  return out;
}

export function hasTag(tags: readonly string[] | undefined, tag: string): boolean {
  const key = tag.toLowerCase();
  return (tags ?? []).some((t) => t.toLowerCase() === key);
}

/** Distinct tags across entities with usage counts, most used first. */
export function tagCounts(
  items: readonly { tags?: readonly string[] | undefined }[],
): { tag: string; count: number }[] {
  const counts = new Map<string, { tag: string; count: number }>();
  for (const item of items) {
    for (const tag of item.tags ?? []) {
      const key = tag.toLowerCase();
      const entry = counts.get(key) ?? { tag, count: 0 };
      entry.count += 1;
      counts.set(key, entry);
    }
  }
  return [...counts.values()].sort((a, b) => b.count - a.count || a.tag.localeCompare(b.tag));
}
